const DEMO_MODE_PREFIX = "si.demo_mode";

/**
 * Translation key generators for demo mode. Per-demo copy is namespaced under the prefix, so a session declares
 * only its `copyNamespace` and the key shape stays a convention rather than per-session config.
 */
export const demoModeKeys = {
    // shared across every demo
    bannerTitle: `${DEMO_MODE_PREFIX}.banner.title`,
    bannerClose: `${DEMO_MODE_PREFIX}.banner.close.tooltip`,
    actionDisabled: `${DEMO_MODE_PREFIX}.action_disabled.tooltip`,
    badge: `${DEMO_MODE_PREFIX}.badge`,
    accessRequestSuccess: `${DEMO_MODE_PREFIX}.access_request.success`,
    accessRequestError: `${DEMO_MODE_PREFIX}.access_request.error`,
    accessRequestSent: `${DEMO_MODE_PREFIX}.access_request.sent`,

    // per-demo, keyed by the session's copy namespace
    bannerSubtitle: (copyNamespace: string) => `${DEMO_MODE_PREFIX}.${copyNamespace}.banner.subtitle`,
    bannerCta: (copyNamespace: string) => `${DEMO_MODE_PREFIX}.${copyNamespace}.banner.cta`,
    calloutTitle: (copyNamespace: string) => `${DEMO_MODE_PREFIX}.${copyNamespace}.callout.title`,
    calloutCta: (copyNamespace: string) => `${DEMO_MODE_PREFIX}.${copyNamespace}.callout.cta`,
    homeBannerTitle: (copyNamespace: string) => `${DEMO_MODE_PREFIX}.${copyNamespace}.home_banner.title`,
    homeBannerDescription: (copyNamespace: string) => `${DEMO_MODE_PREFIX}.${copyNamespace}.home_banner.description`,
    homeBannerCta: (copyNamespace: string) => `${DEMO_MODE_PREFIX}.${copyNamespace}.home_banner.cta`,
    homeBannerLearnMore: (copyNamespace: string) => `${DEMO_MODE_PREFIX}.${copyNamespace}.home_banner.learn_more`,
    companyBannerTitle: (copyNamespace: string) => `${DEMO_MODE_PREFIX}.${copyNamespace}.company_banner.title`,
    companyBannerDescription: (copyNamespace: string) =>
        `${DEMO_MODE_PREFIX}.${copyNamespace}.company_banner.description`,
    companyBannerCta: (copyNamespace: string) => `${DEMO_MODE_PREFIX}.${copyNamespace}.company_banner.cta`,
} as const;
